export const CREATE_COMMITMENT = 'CREATE_COMMITMENTS';
export const CREATE_COMMITMENT_FAILED = 'CREATE_COMMITMENTS_FAILED';
export const CREATE_COMMITMENT_SUCCESS = 'CREATE_COMMITMENT_SUCCESS';

export const CREATE_COMMITMENT_ACTIVITY = 'CREATE_COMMITMENT_ACTIVITY';
export const CREATE_COMMITMENT_ACTIVITY_COMPLETE = 'CREATE_COMMITMENT_ACTIVITY_COMPLETE';

export const DELETE_COMMITMENT = 'DELETE_COMMITMENT';
export const DELETE_COMMITMENT_FAILED = 'DELETE_COMMITMENT_FAILED';
export const DELETE_COMMITMENT_SUCCESS = 'DELETE_COMMITMENT_SUCCESS';